<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ $t("Dashboard.ShowaSummary") }}</b-card-title>
      <!-- datepicker -->
      <div class="d-flex align-items-center">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range' }"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div>
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :height="400"
        :data="chartjsData.latestBarChart.data"
        :options="chartjsData.latestBarChart.options"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCardTitle } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ChartjsComponentBarChart from "./charts-components/ChartjsComponentBarChart.vue";
import chartjsData from "./chartjsData";
import store from "@/store";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    flatPickr,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      chartjsData,
      rangePicker: ["2019-05-01", "2019-05-10"],
    };
  },
  mounted() {
    this.getReportProductCategorySell();
  },
  methods: {
    getReportProductCategorySell() {
      this.chartjsData.latestBarChart.data.labels = [];
      this.chartjsData.latestBarChart.data.datasets[0].data = [];
      store
        .dispatch("dashboard-seller/getReportProductCategorySell")
        .then((response) => {
          response.data.data.map((item) => {
            this.chartjsData.latestBarChart.data.labels.push(item.categoryName);
            this.chartjsData.latestBarChart.data.datasets[0].data.push(
              item.salesSummaryPriceProduct
            );
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
